import React, { useState, useCallback, useRef,useEffect } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../../dynamicFormBuilder/FormField';
import SalesOrderSearchFormLayout from './SalesOrderSearchFormLayout';
import {
    GetLookupData
} from "../../../../services/SalesOrderService";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const SalesOrdersFilters = (props) => {
    const getProfileUrl = "om/SaleOrder/GetProfiles";
    const getCustomerUrl = "om/SaleOrder/GetCustomers";
    const [selectedItems, setSelectedItems] = useState([]);
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const [forceRender, setForceRender] = useState(false);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        ShippingDateFrom: '',
        ShippingDateTo: '',
        OrderDateFrom: '',
        OrderDateTo: '',
        ProfileCode: '',
        RCustomer: '',
        TransactionNumber: '',
        PurchaseOrderNumber: '',
        code1_OMHeader: '',
        code2_OMHeader: '',
        code3_OMHeader: '',
        code4_OMHeader: '',
    };
    
 
    
 
    
    const [formFields, setformFields] = useState(initialFormFields);

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
        },
        [selectedItems, setSelectedItems],
    );
    const handleFormSubmit = async (e) => {
        e.event.stopPropagation();
        props.searchData(formFields);
    };
    const handleFieldChange = useCallback((name, value) => {

    }, []);
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
    };
    const formRefs = useRef({});
    const handleSalesOrderSearchFormLoad = useCallback(() => {
        GetLookupData("RCustomer", getCustomerUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
    }, []);
    useEffect(() => {
        props.searchData(formFields);
      }, []);
    return (
        <form>
            <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                    if (e.currentTarget === e.target) {
                        selectionChanged(e, e.target);
                    }
                }}
                itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                        <Item location="before">
                            <div className="title">
                                <h6
                                    style={{
                                        color: window._env_.Color2
                                    }}
                                >
                                  Sales Order Management - (Sales Orders)
                                </h6>
                            </div>
                        </Item>

                        <Item location="after">
                            <Button className="accordianButton" onClick={handleFormSubmit}  text="Search" type="default" />
                        </Item>
                        <Item location="after">
                            <Button className="accordianButton" onClick={handleReset} text="Reset" />
                        </Item>
                    </Toolbar>
                )}
                itemRender={(itemProps) => (
                    <div>
                        <FormField
                            currrentUser={currentUser}
                            layoutId='2BC07861-61D5-4450-86E0-00DD4E0AE168'
                            layoutName='MyTestForm'
                            defaultFormSchema={SalesOrderSearchFormLayout}
                            formFields={formFields}
                            setformFields={setformFields}
                            handleFieldValueChange={handleFieldChange}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={formRefs}
                            onFormLoad={handleSalesOrderSearchFormLoad}
                            noSpacingBeforeFirstRow={true}
                        />

                    </div>
                )}
                id="accordion-container" className="accordion-height"
            />
        </form>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(SalesOrdersFilters);